//production environment.ts
export const environment = {
  production: true,
  // api: 'https://api.stg.jnardc.netoyed.co.in/api/',
  // clientUrl: 'https://staging.jnarddc.netoyed.co.in/',
  // imageurl: 'https://jnardc-dev.s3.ap-south-1.amazonaws.com/',

  //dev
  api: 'https://jnardc.dev.netoyed.co.in/api/',
  clientUrl: 'https://dev.jnarddc.netoyed.co.in/',
  imageurl: 'https://jnardc-dev.s3.ap-south-1.amazonaws.com/',
};
